import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import toast from 'react-hot-toast';

const CertificateViewModal = ({
    show,
    onHide,
    certificate
}) => {
    const pdfUrl = certificate?.url
        ? `${certificate.url}#toolbar=0&navpanes=0`
        : null;
    const handleDownload = () => {
        if (certificate?.url) {
            // Create temporary anchor and trigger download
            const link = document.createElement('a');
            link.href = certificate.downloadUrl || certificate.url;
            link.download = certificate.filename || 'certificate.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            toast.success('Download started');
        } else {
            toast.error('Download URL not available');
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Certificate - BRC: {certificate?.brcNumber}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {certificate?.url ? (
                    <div>
                        <div className="mb-3">
                            <strong>Shipping Bill Number:</strong> {certificate.sbNumber}
                        </div>
                        <div className="mb-3">
                            <iframe
                                 src={pdfUrl}
                                width="100%"
                                height="600px"
                                title="Certificate Preview"
                                style={{ border: '1px solid #ddd', borderRadius: '4px' }}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="text-center py-5 text-muted">
                        <i className="bi bi-file-earmark-pdf" style={{ fontSize: '48px' }}></i>
                        <p className="mt-3">Certificate not available</p>
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
                <Button
                    variant="primary"
                    onClick={handleDownload}
                    disabled={!certificate?.url}
                >
                    <i className="bi bi-download"></i> Download ({certificate?.filename || 'certificate.pdf'})
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CertificateViewModal;